import { ClipboardList, Construction, type LucideIcon } from 'lucide-react'

interface RoutePlaceholderProps {
  eyebrow: string
  title: string
  description: string
  icon?: LucideIcon
  stationId?: string
}

export function RoutePlaceholder({
  eyebrow,
  title,
  description,
  icon: Icon = ClipboardList,
  stationId,
}: RoutePlaceholderProps) {
  return (
    <section className="route-placeholder" aria-labelledby="placeholder-title">
      <div className="route-placeholder__index" aria-hidden="true">
        <span>MH</span>
        <span>00</span>
      </div>
      <div className="route-placeholder__body">
        <div className="section-kicker"><span className="kicker-dot" />{eyebrow}</div>
        <div className="route-placeholder__icon"><Icon size={24} strokeWidth={1.6} /></div>
        <h1 id="placeholder-title">{title}</h1>
        <p>{description}</p>
        {stationId && <code className="route-placeholder__code">رقم المحطة: {stationId}</code>}
        <div className="route-placeholder__status">
          <Construction size={15} aria-hidden="true" />
          <span>هذا القسم قيد التجهيز وسيكون متاحًا قريبًا.</span>
        </div>
      </div>
    </section>
  )
}
